import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import icon_careers from './static/icon-careers.png';
import icon_company from './static/icon-company.png';
import icon_openings from './static/icon-openings.png';
import icon_partnershiops from './static/icon-partnershiops.png';
import icon_person from './static/icon-person.png';
import icon_person_big from './static/icon-person-big.png';
import icon_recycle from './static/icon-recycle.png';
import icon_recycle_big from './static/icon-recycle-big.png';
import icon_graph from './static/icon-graph.png';
import icon_graph_big from './static/icon-graph-big.png';
import icon_mobile from './static/icon-mobile.png';
import icon_pointer from './static/icon-pointer.png';
import icon_chatting from './static/icon-chatting.png';
import icon_list from './static/icon-list.png';
import icon_list_big from './static/icon-list-big.png';
import icon_speed from './static/icon-speed.png';
import icon_speed_big from './static/icon-speed-big.png';
import icon_alarm from './static/icon-alarm.png';
import icon_alarm_big from './static/icon-alarm-big.png';
import icon_play_circle from './static/icon-play-circle.svg';
import icon_back from './static/icon-back.png';
import icon_hvac_load_calc from './static/hvac-load-calc.png';
import icon_business_valuation from './static/business-valuation.png';
import icon_color_wheel from './static/icon-color-wheel.svg';

export const STIcon = ({ type, size, className, ...otherProps }) => {
  return type === 'icon-play' ? (
    <svg
      width="15"
      height="21"
      viewBox="0 0 15 21"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path d="M14.3281 10.6505L0.675212 20.7401L0.675213 0.560869L14.3281 10.6505Z" />
    </svg>
  ) : type === 'icon-delivery-car' ? (
    <svg
      width="30"
      height="20"
      viewBox="0 0 30 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path d="M6.89458 3.60156H5.65234V10.3717H6.89458V3.60156Z" fill="#009DE6" />
      <path
        d="M6.27511 19.9994C4.72232 19.9994 3.41797 18.6951 3.41797 17.1423C3.41797 15.5895 4.72232 14.2852 6.27511 14.2852C7.82791 14.2852 9.13226 15.5895 9.13226 17.1423C9.13226 18.6951 7.89002 19.9994 6.27511 19.9994ZM6.27511 15.4653C5.40555 15.4653 4.6602 16.2106 4.6602 17.1423C4.6602 18.0119 5.40555 18.7572 6.27511 18.7572C7.14468 18.7572 7.89002 18.0119 7.89002 17.1423C7.89002 16.2106 7.20679 15.4653 6.27511 15.4653Z"
        fill="#009DE6"
      />
      <path
        d="M12.5466 17.7631H8.50932V16.5208H11.3043V4.2227H6.58385L1.24224 10.6202V16.5208H4.03727V17.7631H0V10.1233L5.96273 2.98047H12.5466V17.7631Z"
        fill="#009DE6"
      />
      <path
        d="M22.7946 19.9999C21.2418 19.9999 19.9375 18.6956 19.9375 17.1428C19.9375 15.59 21.2418 14.2856 22.7946 14.2856C24.3474 14.2856 25.6518 15.59 25.6518 17.1428C25.7139 18.6956 24.4096 19.9999 22.7946 19.9999ZM22.7946 15.4658C21.9251 15.4658 21.1797 16.2111 21.1797 17.0807C21.1797 17.9502 21.9251 18.6956 22.7946 18.6956C23.6642 18.6956 24.4096 17.9502 24.4096 17.0807C24.4717 16.2111 23.7263 15.4658 22.7946 15.4658Z"
        fill="#009DE6"
      />
      <path
        d="M29.1929 17.764H24.8451V16.5217H27.9507V1.24224H12.5469V16.5217H20.2488V17.764H11.3047V0H29.1929V17.764Z"
        fill="#009DE6"
      />
    </svg>
  ) : type === 'icon-pause' ? (
    <svg
      width="30"
      height="30"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47.607 47.607"
      {...otherProps}
    >
      <g>
        <path
          d="M17.991,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631C4.729,2.969,7.698,0,11.36,0
        l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z"
          fill="#ffffff"
        />
        <path
          d="M42.877,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631
        C29.616,2.969,32.585,0,36.246,0l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ) : type === 'icon-graph-horizontal' ? (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path d="M1.57547 0H0V25.2075H1.57547V0Z" fill="#0B1A21" />
      <path
        d="M22.0569 5.67168L20.9541 4.56885L22.6871 2.83584L20.9541 1.10283L22.0569 0L24.8928 2.83584L22.0569 5.67168Z"
        fill="#0B1A21"
      />
      <path d="M23.7909 2.05078H0.789062V3.62625H23.7909V2.05078Z" fill="#0B1A21" />
      <path
        d="M15.7542 12.1321L14.6514 11.0293L16.3844 9.29629L14.6514 7.56328L15.7542 6.46045L18.59 9.29629L15.7542 12.1321Z"
        fill="#0B1A21"
      />
      <path d="M17.489 8.50781H0.789062V10.0833H17.489V8.50781Z" fill="#0B1A21" />
      <path
        d="M19.6936 18.5887L18.5908 17.4858L20.3238 15.7528L18.5908 14.0198L19.6936 12.917L22.5295 15.7528L19.6936 18.5887Z"
        fill="#0B1A21"
      />
      <path d="M21.4277 14.9688H0.789062V16.5442H21.4277V14.9688Z" fill="#0B1A21" />
      <path
        d="M15.7542 24.9725L14.6514 23.8696L16.3844 22.1366L14.6514 20.4036L15.7542 19.3008L18.59 22.1366L15.7542 24.9725Z"
        fill="#0B1A21"
      />
      <path d="M17.488 21.3516H0.788086V22.927H17.488V21.3516Z" fill="#0B1A21" />
    </svg>
  ) : type === 'icon-graph-circle' ? (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M12.6037 25.6371C5.67168 25.6371 0 19.9655 0 13.0334C0 6.10137 5.67168 0.429688 12.6037 0.429688C19.5358 0.429688 25.2075 6.10137 25.2075 13.0334C25.2075 19.9655 19.5358 25.6371 12.6037 25.6371ZM12.6037 2.00515C6.53818 2.00515 1.57547 6.96787 1.57547 13.0334C1.57547 19.099 6.53818 24.0617 12.6037 24.0617C18.6693 24.0617 23.632 19.099 23.632 13.0334C23.632 6.96787 18.6693 2.00515 12.6037 2.00515Z"
        fill="#0B1A21"
      />
      <path
        d="M12.604 18.5473C9.53182 18.5473 7.08984 16.1053 7.08984 13.0332C7.08984 9.96102 9.53182 7.51904 12.604 7.51904C15.6761 7.51904 18.1181 9.96102 18.1181 13.0332C18.1181 16.1053 15.6761 18.5473 12.604 18.5473ZM12.604 9.09451C10.3983 9.09451 8.66531 10.8275 8.66531 13.0332C8.66531 15.2388 10.3983 16.9718 12.604 16.9718C14.8096 16.9718 16.5426 15.2388 16.5426 13.0332C16.5426 10.8275 14.8096 9.09451 12.604 9.09451Z"
        fill="#0B1A21"
      />
      <path d="M13.3909 17.7607H11.8154V24.8503H13.3909V17.7607Z" fill="#0B1A21" />
      <path d="M24.4216 12.2461H17.332V13.8216H24.4216V12.2461Z" fill="#0B1A21" />
      <path
        d="M23.8938 17.3186L19.0479 12.4727L17.9338 13.5867L22.7798 18.4326L23.8938 17.3186Z"
        fill="#0B1A21"
      />
      <path
        d="M21.5198 20.8352L16.6182 15.9336L15.5042 17.0476L20.4058 21.9493L21.5198 20.8352Z"
        fill="#0B1A21"
      />
      <path
        d="M17.9876 23.2249L13.1416 18.3789L12.0276 19.4929L16.8735 24.3389L17.9876 23.2249Z"
        fill="#0B1A21"
      />
      <path d="M13.3909 1.21533H11.8154V8.30493H13.3909V1.21533Z" fill="#0B1A21" />
    </svg>
  ) : type === 'icon-note' ? (
    <svg
      width="20"
      height="26"
      viewBox="0 0 20 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M19.8509 25.2077H0V2.28467H6.93205L6.38064 4.56909H13.549L12.9976 2.28467H19.9296V25.2077H19.8509ZM1.57547 23.6322H18.3542V3.86013H14.9669L15.5183 6.14456H4.33253L4.88394 3.86013H1.57547V23.6322Z"
        fill="#0B1A21"
      />
      <path
        d="M15.5178 6.14432H4.33203L5.9075 0H14.0211L15.5178 6.14432ZM6.38014 4.56885H13.5485L12.7608 1.57547H7.0891L6.38014 4.56885Z"
        fill="#0B1A21"
      />
      <path d="M16.1477 9.92969H14.5723V21.7457H16.1477V9.92969Z" fill="#0B1A21" />
      <path d="M12.5237 12.293H10.9482V21.7458H12.5237V12.293Z" fill="#0B1A21" />
      <path d="M8.90261 14.6562H7.32715V21.7458H8.90261V14.6562Z" fill="#0B1A21" />
      <path d="M5.27761 17.019H3.70215V21.7454H5.27761V17.019Z" fill="#0B1A21" />
    </svg>
  ) : type === 'icon-person-speak' ? (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M14.2577 13.9429V10.6344H11.8945V0H25.2072V10.6344H19.4568L14.2577 13.9429ZM13.47 9.05893H15.8332V11.0283L18.9841 8.98016H23.6318V1.57547H13.47V9.05893Z"
        fill="#0B1A21"
      />
      <path
        d="M15.0457 25.2048H0V24.4171C0 20.2421 3.38725 16.9336 7.48346 16.9336C11.6584 16.9336 14.9669 20.3208 14.9669 24.4171V25.2048H15.0457ZM1.65424 23.6293H13.3915C12.9976 20.7147 10.5556 18.5091 7.48346 18.5091C4.49008 18.5091 2.04811 20.7147 1.65424 23.6293Z"
        fill="#0B1A21"
      />
      <path
        d="M7.48325 18.5114C5.12005 18.5114 3.22949 16.6209 3.22949 14.2577C3.22949 11.8945 5.12005 10.0039 7.48325 10.0039C9.84645 10.0039 11.737 11.8945 11.737 14.2577C11.737 16.6209 9.84645 18.5114 7.48325 18.5114ZM7.48325 11.5794C5.98656 11.5794 4.80496 12.761 4.80496 14.2577C4.80496 15.7544 5.98656 16.936 7.48325 16.936C8.97994 16.936 10.1615 15.7544 10.1615 14.2577C10.1615 12.761 8.97994 11.5794 7.48325 11.5794Z"
        fill="#0B1A21"
      />
      <path d="M16.3841 5.19971H14.8086V7.72045H16.3841V5.19971Z" fill="#0B1A21" />
      <path d="M19.3802 4.01953H17.8047V7.72188H19.3802V4.01953Z" fill="#0B1A21" />
      <path d="M22.2942 2.75781H20.7188V7.64176H22.2942V2.75781Z" fill="#0B1A21" />
    </svg>
  ) : type === 'icon-success' ? (
    <svg
      width="24"
      height="17"
      viewBox="0 0 24 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path d="M2 7.52273L9.36364 14.2727L22.5568 2" stroke="#00A9F7" strokeWidth="3.68182" />
    </svg>
  ) : type === 'icon-table-tick' ? (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.7232 3.68397L9.97089 17.719C9.6023 18.0937 9.00557 18.0937 8.63847 17.719L0.275328 9.12744C-0.0917761 8.75119 -0.0917761 8.13979 0.275328 7.76581L2.27359 5.72755C2.64218 5.35206 3.23892 5.35206 3.60602 5.72755L9.31174 11.5905L20.3903 0.281049C20.7574 -0.0936828 21.3541 -0.0936828 21.7242 0.281049L23.7224 2.32235C24.0933 2.69784 24.0933 3.30924 23.7232 3.68397Z"
        fill="#4AB971"
      />
    </svg>
  ) : type === 'icon-warning' ? (
    <svg
      width="7px"
      height="27"
      viewBox="0 0 14 42"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-1014.000000, -882.000000)">
          <circle stroke="#2CB9FB" strokeWidth="4" cx="1017.5" cy="901.5" r="47.5"></circle>
          <g id="warning-icon" transform="translate(1014.000000, 882.000000)" fill="#FFFFFF">
            <path
              d="M7,30.1538462 C10.2712251,30.1538462 12.9230769,32.805698 12.9230769,36.0769231 C12.9230769,39.3481481 10.2712251,42 7,42 C3.72877494,42 1.07692308,39.3481481 1.07692308,36.0769231 C1.07692308,32.805698 3.72877494,30.1538462 7,30.1538462 Z M14,0 L11.8461538,23.6923077 L2.15384615,23.6923077 L1.77635684e-15,0 L14,0 Z"
              id="warning"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ) : type === 'icon-table-untick' ? (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6042 0.582554L9 6.1869L3.39579 0.582554C2.61891 -0.194193 1.35944 -0.194193 0.582559 0.582554C-0.194186 1.35944 -0.194186 2.6189 0.582559 3.39578L6.18691 9L0.582559 14.6042C-0.194186 15.3811 -0.194186 16.6406 0.582559 17.4174C1.35944 18.1942 2.61891 18.1942 3.39579 17.4174L9 11.8131L14.6042 17.4174C15.3811 18.1942 16.6406 18.1942 17.4174 17.4174C18.1942 16.6406 18.1942 15.3811 17.4174 14.6042L11.8131 9L17.4174 3.39578C18.1942 2.6189 18.1942 1.35944 17.4174 0.582554C16.6406 -0.194193 15.3811 -0.194193 14.6042 0.582554Z"
        fill="#FF0000"
      />
    </svg>
  ) : type === 'icon-category' ? (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="4" height="4" fill="#637984" />
      <rect x="7" width="4" height="4" fill="#637984" />
      <rect y="7" width="4" height="4" fill="#637984" />
      <rect x="7" y="7" width="4" height="4" fill="#637984" />
    </svg>
  ) : type === 'icon-podcast-mark' ? (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.7773 12.6032C12.212 12.6032 13.3751 11.4402 13.3751 10.0054C13.3751 8.57068 12.212 7.40759 10.7773 7.40759C9.34256 7.40759 8.17947 8.57068 8.17947 10.0054C8.17947 11.4402 9.34256 12.6032 10.7773 12.6032Z"
        fill="black"
      />
      <path
        d="M10.7771 13.5807C9.2447 13.5807 8.02708 14.3819 8.19517 15.3199L8.89945 22.8659C8.89945 23.4923 9.74008 24 10.7771 24C11.814 24 12.6547 23.4922 12.6547 22.8659L13.359 15.3199C13.5267 14.3802 12.3075 13.5807 10.7771 13.5807Z"
        fill="black"
      />
      <path
        d="M10.777 0C4.83459 0 0 4.83459 0 10.7771C0 15.5138 3.07305 19.5436 7.32897 20.9852L7.20175 19.6221C3.7068 18.2042 1.2346 14.7749 1.2346 10.7771C1.2346 5.51528 5.51534 1.2346 10.777 1.2346C16.0389 1.2346 20.3197 5.51534 20.3197 10.7771C20.3197 14.7748 17.8475 18.2041 14.3525 19.6221L14.2252 20.9852C18.4813 19.5436 21.5543 15.5138 21.5543 10.777C21.5543 4.83459 16.7196 0 10.777 0Z"
        fill="black"
      />
      <path
        d="M10.777 3.49817C6.76336 3.49817 3.49808 6.76351 3.49808 10.7772C3.49808 13.3893 4.88177 15.6835 6.954 16.9679L6.81649 15.495C6.80797 15.4377 6.80472 15.3806 6.80043 15.3235C5.53446 14.2147 4.73268 12.5883 4.73268 10.7772C4.73268 7.44426 7.44405 4.73277 10.777 4.73277C14.11 4.73277 16.8215 7.44426 16.8215 10.7772C16.8215 12.5883 16.0197 14.2148 14.7537 15.3235C14.7494 15.3806 14.7461 15.4376 14.7377 15.4947L14.6001 16.9678C16.6724 15.6834 18.0561 13.3893 18.0561 10.7772C18.0561 6.76351 14.7907 3.49817 10.777 3.49817Z"
        fill="black"
      />
    </svg>
  ) : type === 'multi-step-hvac' ? (
    <img src={`${require('./static/hvac.svg')}`} alt="HVAC Icon" />
  ) : type === 'multi-step-plumbing' ? (
    <img src={`${require('./static/plumbing.svg')}`} alt="Plumbing Icon" />
  ) : type === 'multi-step-electorical' ? (
    <img src={`${require('./static/electorical.svg')}`} alt="Electorical Icon" />
  ) : type === 'multi-step-garage' ? (
    <img src={`${require('./static/door.svg')}`} alt="Door Icon" />
  ) : type === 'multi-step-chimney' ? (
    <img src={`${require('./static/chimney.svg')}`} alt="Chimney Icon" />
  ) : type === 'multi-step-water' ? (
    <img src={`${require('./static/water-treatment.svg')}`} alt="Water Treatment Icon" />
  ) : type === 'multi-step-residential' ? (
    <img src={`${require('./static/multi-step-residential.svg')}`} alt="Residential Icon" />
  ) : type === 'multi-step-commercial' ? (
    <img src={`${require('./static/multi-step-commercial.svg')}`} alt="Commercial Icon" />
  ) : type === 'multi-step-service-replacement' ? (
    <img src={`${require('./static/multi-step-service-replacement.svg')}`} alt="Residential Icon" />
  ) : type === 'multi-step-construction-remodel' ? (
    <img src={`${require('./static/multi-step-construction-remodel.svg')}`} alt="Commercial Icon" />
  ) : type === 'none-user-avatar-icon' ? (
    <img src={`${require('./static/none-user-avatar-icon.svg')}`} alt="none user avatar icon" />
  ) : type === 'part-time-user-avatar-icon' ? (
    <img
      src={`${require('./static/part-time-user-avatar-icon.svg')}`}
      alt="part time user avatar icon"
    />
  ) : type === 'one-user-avatar-icon' ? (
    <img src={`${require('./static/one-user-avatar-icon.svg')}`} alt="one user avatar icon" />
  ) : type === 'two-user-avatar-icon' ? (
    <img src={`${require('./static/two-user-avatar-icon.svg')}`} alt="two user avatar icon" />
  ) : type === 'three-user-avatar-icon' ? (
    <img src={`${require('./static/three-user-avatar-icon.svg')}`} alt="three user avatar icon" />
  ) : type === 'four-nine-user-avatar-icon' ? (
    <img
      src={`${require('./static/four-nine-user-avatar-icon.svg')}`}
      alt="four nine user avatar icon"
    />
  ) : type === 'ten-thirty-user-avatar-icon' ? (
    <img
      src={`${require('./static/ten-thirty-user-avatar-icon.svg')}`}
      alt="ten thirty user avatar icon"
    />
  ) : type === 'plus-user-avatar-icon' ? (
    <img src={`${require('./static/plus-user-avatar-icon.svg')}`} alt="plus user avatar icon" />
  ) : type === 'rectangle-grey' ? (
    <img src={`${require('./static/rectangle-grey.svg')}`} alt="rectangle grey icon" />
  ) : type === 'multi-step-other' ? (
    <></>
  ) : type === 'articles_icon' ? (
    <img src={`${require('./static/articles_icon.svg')}`} alt="Articles Icon" />
  ) : type === 'videos_icon' ? (
    <img src={`${require('./static/videos_icon.svg')}`} alt="Videos Icon" />
  ) : type === 'webinars_icon' ? (
    <img src={`${require('./static/webinars_icon.svg')}`} alt="Webinars Icon" />
  ) : type === 'podcasts_icon' ? (
    <img src={`${require('./static/podcasts_icon.svg')}`} alt="Podcasts Icon" />
  ) : type === 'icon-popular' ? (
    <img src={`${require('./static/icon-popular.svg')}`} alt="Popular Icon" />
  ) : type === 'tools_icon' ? (
    <img src={`${require('./static/tools_icon.svg')}`} alt="Tools Icon" />
  ) : type === 'icon-arrow-right' ? (
    <img
      src={`${require('./static/icon-arrow-right.svg')}`}
      alt="Arrow Right Icon"
      {...otherProps}
    />
  ) : type === 'icon-arrow-right1' ? (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...otherProps}
    >
      <path d="M9.63647 1L15.6365 7L9.63647 13" stroke="#0B1A21" strokeWidth="2.5" />
      <path d="M0 7L15.7584 7" stroke="#0B1A21" strokeWidth="2.5" />
    </svg>
  ) : type === 'icon-arrow-left' ? (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M7.05025 0.99996L2.10051 5.94971L7.05025 10.8995" stroke="#009DE6" strokeWidth="2" />
      <path d="M15 5.94971L2 5.94971" stroke="#009DE6" strokeWidth="2" />
    </svg>
  ) : type === 'icon-slider-arrow-right' ? (
    <svg width="21" height="33" viewBox="0 0 21 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 2L19 16.5L2 31"
        stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : type === 'icon-slider-arrow-left' ? (
    <svg width="21" height="33" viewBox="0 0 21 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 2L19 16.5L2 31"
        stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : type === 'icon-breadcrumb' ? (
    <img
      src={`${require('./static/icon-breadcrumb.svg')}`}
      alt="Breadcrumb Icon"
      className={className}
      {...otherProps}
    />
  ) : type === 'icon-selected' ? (
    <img
      src={`${require('./static/icon-selected.svg')}`}
      alt="Selected Icon"
      className={className}
      {...otherProps}
    />
  ) : type === 'icon-color-wheel' ? (
    <img
      src={`${require('./static/icon-color-wheel.svg')}`}
      alt="Color Wheel Icon"
      className={className}
      {...otherProps}
    />
  ) : type === 'icon-retake' ? (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <g clip-path="url(#clip0)">
        <path
          d="M19.5669 10.739L16.234 14.0724C15.9564 14.35 15.5792 14.5065 15.1861 14.5065C14.793 14.5065 14.4157 14.3505 14.1386 14.0724L10.8052 10.739C10.2269 10.1607 10.2269 9.22245 10.8052 8.64417C11.3835 8.06539 12.3218 8.06539 12.9001 8.64417L13.8048 9.54888C13.5737 6.76412 11.2388 4.56802 8.39527 4.56802C5.40063 4.56802 2.96304 7.00511 2.96304 10.0002C2.96304 12.9949 5.40063 15.4325 8.39527 15.4325C9.21356 15.4325 9.87679 16.0957 9.87679 16.914C9.87679 17.7323 9.21356 18.3955 8.39527 18.3955C3.76651 18.3955 0 14.6295 0 10.0002C0 5.371 3.76651 1.60498 8.39527 1.60498C12.8082 1.60498 16.4281 5.02877 16.7589 9.35727L17.471 8.64417C18.0498 8.06539 18.9881 8.06539 19.5659 8.64417C20.1447 9.22196 20.1447 10.1603 19.5669 10.739Z"
          fill="#0B1A21"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20.0005" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : type === 'icon-increase' ? (
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.5 0L16.7272 14.25H0.272758L8.5 0Z" fill="#CFD8DC" />
    </svg>
  ) : type === 'icon-url' ? (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
        <path
          d="M9.02786 6.32677C6.15575 9.29838 6.7825 14.2299 10.0725 16.4144C10.1809 16.4865 10.3251 16.4722 10.4182 16.3812C11.1108 15.7044 11.6967 15.0489 12.2098 14.2152C12.2883 14.0877 12.2395 13.9222 12.1078 13.8508C11.606 13.579 11.1066 13.0692 10.8255 12.5307L10.8252 12.5309C10.4884 11.8604 10.3738 11.1087 10.5521 10.3325C10.5523 10.3325 10.5525 10.3326 10.5526 10.3326C10.7578 9.33877 11.8247 8.41429 12.6396 7.55931C12.6379 7.55874 12.6362 7.55812 12.6345 7.55755L15.6876 4.44139C16.9044 3.19957 18.9057 3.18933 20.1351 4.41867C21.3768 5.63535 21.3974 7.6468 20.1807 8.88858L18.3314 10.7903C18.2458 10.8783 18.218 11.0067 18.2581 11.1228C18.6839 12.3576 18.7886 14.0986 18.5033 15.4141C18.4953 15.4509 18.5407 15.475 18.567 15.4481L22.503 11.4309C25.0173 8.86462 24.996 4.68644 22.4556 2.14602C19.863 -0.446555 15.6424 -0.424979 13.0764 2.19389L9.04363 6.30991C9.03829 6.31553 9.03324 6.32125 9.02786 6.32677Z"
          fill="#0B1A21"
        />
        <path
          d="M16.386 16.9803C16.3859 16.9805 16.3858 16.9806 16.3858 16.9808C16.3883 16.9797 16.3906 16.9787 16.3931 16.9776C17.1964 15.5088 17.3545 13.8242 16.9781 12.182L16.9764 12.1838L16.9745 12.183C16.617 10.7204 15.6362 9.26796 14.3041 8.37373C14.1896 8.29681 14.0065 8.30572 13.8992 8.3925C13.2245 8.93808 12.564 9.6377 12.1282 10.5305C12.0597 10.6707 12.111 10.839 12.2459 10.9173C12.7516 11.211 13.2084 11.6409 13.5142 12.2116L13.5147 12.2113C13.753 12.6145 13.9879 13.3795 13.8358 14.2014C13.8357 14.2014 13.8355 14.2014 13.8354 14.2014C13.6935 15.2912 12.593 16.2909 11.7181 17.1916L11.7186 17.192C11.0526 17.873 9.35976 19.5988 8.68191 20.2913C7.46523 21.5331 5.45378 21.5536 4.212 20.337C2.97022 19.1203 2.9497 17.1088 4.16637 15.8671L6.02118 13.9596C6.10524 13.8732 6.13382 13.7475 6.09643 13.6329C5.68459 12.3693 5.57175 10.6674 5.83171 9.3535C5.83895 9.31688 5.79389 9.29349 5.76775 9.32016L1.89101 13.2769C-0.64913 15.8695 -0.627602 20.0905 1.93892 22.657C4.53135 25.1971 8.73063 25.1541 11.2707 22.5617C12.1531 21.5747 15.9304 18.0773 16.386 16.9803Z"
          fill="#0B1A21"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24.375" height="24.375" fill="white" transform="translate(0 0.1875)" />
        </clipPath>
      </defs>
    </svg>
  ) : type === 'icon-facebook' ? (
    <svg width="13" height="25" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6508 4.04727H12.876V0.171641C12.4921 0.118828 11.1718 0 9.63414 0C6.42578 0 4.22797 2.01805 4.22797 5.72711V9.14062H0.6875V13.4733H4.22797V24.375H8.56875V13.4743H11.966L12.5053 9.14164H8.56774V6.15672C8.56875 4.90445 8.90594 4.04727 10.6508 4.04727Z"
        fill="#0B1A21"
      />
    </svg>
  ) : type === 'icon-twitter' ? (
    <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25 3.15469C24.0703 3.5625 23.0797 3.83281 22.0469 3.96406C23.1094 3.32969 23.9203 2.33281 24.3016 1.13125C23.3109 1.72187 22.2172 2.13906 21.0516 2.37188C20.1109 1.37031 18.7703 0.75 17.3078 0.75C14.4703 0.75 12.1859 3.05313 12.1859 5.87656C12.1859 6.28281 12.2203 6.67344 12.3047 7.04531C8.04375 6.8375 4.27344 4.79531 1.74062 1.68438C1.29844 2.45156 1.03906 3.32969 1.03906 4.275C1.03906 6.05 1.95312 7.62344 3.31562 8.53437C2.49219 8.51875 1.68437 8.27969 1 7.90313C1 7.91875 1 7.93906 1 7.95937C1 10.45 2.77656 12.5188 5.10625 12.9953C4.68906 13.1094 4.23438 13.1641 3.7625 13.1641C3.43438 13.1641 3.10312 13.1453 2.79219 13.0766C3.45625 15.1062 5.34063 16.5984 7.58125 16.6469C5.8375 18.0109 3.62344 18.8328 1.22656 18.8328C0.80625 18.8328 0.403125 18.8141 0 18.7625C2.27031 20.2266 4.96094 21.0625 7.8625 21.0625C17.2937 21.0625 22.45 13.25 22.45 6.47812C22.45 6.25156 22.4422 6.03281 22.4312 5.81563C23.4484 5.09375 24.3031 4.19219 25 3.15469Z"
        fill="#0B1A21"
      />
    </svg>
  ) : type === 'icon-linkedin' ? (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
        <path
          d="M22.6171 0.4375H1.75794C0.78701 0.4375 0 1.22451 0 2.19544V23.0546C0 24.0255 0.78701 24.8125 1.75794 24.8125H22.6171C23.588 24.8125 24.375 24.0255 24.375 23.0546V2.19544C24.375 1.22451 23.588 0.4375 22.6171 0.4375V0.4375ZM8.64595 18.8616H5.67774V9.93165H8.64595V18.8616ZM7.16194 8.71227H7.1426C6.14656 8.71227 5.50238 8.02661 5.50238 7.16967C5.50238 6.2934 6.16628 5.62671 7.18165 5.62671C8.19703 5.62671 8.82188 6.2934 8.84122 7.16967C8.84122 8.02661 8.19703 8.71227 7.16194 8.71227ZM19.3487 18.8616H16.3809V14.0843C16.3809 12.8837 15.9511 12.0649 14.8771 12.0649C14.0572 12.0649 13.5689 12.6172 13.3543 13.1504C13.2758 13.3412 13.2566 13.6078 13.2566 13.8747V18.8616H10.2886C10.2886 18.8616 10.3275 10.7694 10.2886 9.93165H13.2566V11.196C13.6511 10.5876 14.3568 9.72206 15.9316 9.72206C17.8844 9.72206 19.3487 10.9984 19.3487 13.7412V18.8616Z"
          fill="#0B1A21"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24.375" height="24.375" fill="white" transform="translate(0 0.4375)" />
        </clipPath>
      </defs>
    </svg>
  ) : type === 'icon-calendar' ? (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1953 1.09375H10.9375V0.4375C10.9375 0.195891 10.7416 0 10.5 0C10.2584 0 10.0625 0.195891 10.0625 0.4375V1.09375H3.9375V0.4375C3.9375 0.195891 3.74164 0 3.5 0C3.25836 0 3.0625 0.195891 3.0625 0.4375V1.09375H1.80469C0.809566 1.09375 0 1.90332 0 2.89844V12.1953C0 13.1904 0.809566 14 1.80469 14H12.1953C13.1904 14 14 13.1904 14 12.1953V2.89844C14 1.90332 13.1904 1.09375 12.1953 1.09375ZM13.125 12.1953C13.125 12.7088 12.7088 13.125 12.1953 13.125H1.80469C1.29123 13.125 0.875 12.7088 0.875 12.1953V4.94922C0.875 4.87372 0.936223 4.8125 1.01172 4.8125H12.9883C13.0638 4.8125 13.125 4.87372 13.125 4.94922V12.1953Z"
        fill="#637984"
      />
    </svg>
  ) : type === 'icon-timer' ? (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C13.9959 3.13574 10.8643 0.00413087 7 0ZM7 13C3.68628 13 0.999992 10.3137 0.999992 7C0.999992 3.68628 3.68628 0.999992 7 0.999992C10.3137 0.999992 13 3.68628 13 7C12.9964 10.3123 10.3123 12.9964 7 13Z"
        fill="#637984"
      />
      <path
        d="M7.00001 2.49988C6.72385 2.49988 6.5 2.72374 6.5 2.99989V6.4999H3.00001C2.72386 6.4999 2.5 6.72376 2.5 6.99991C2.5 7.27607 2.72386 7.49989 3.00001 7.49989H7.00001C7.27616 7.49989 7.50002 7.27604 7.50002 6.99988V2.99989C7.50002 2.72374 7.27616 2.49988 7.00001 2.49988Z"
        fill="#637984"
      />
    </svg>
  ) : type === 'icon-live' ? (
    <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.34902 13.6003C-0.568978 9.71354 -0.568978 4.2858 2.34902 0.399061C2.68009 -0.0413397 3.30803 -0.132206 3.74943 0.19986C4.19083 0.531927 4.27969 1.15886 3.94863 1.60026C1.56096 4.779 1.56096 9.2204 3.94863 12.3991C4.27969 12.8405 4.19083 13.4674 3.74943 13.7995C3.30989 14.1292 2.68169 14.0437 2.34902 13.6003Z"
        fill="#637984"
      />
      <path
        d="M18.5503 13.7995C18.1089 13.4675 18.02 12.8405 18.3511 12.3991C20.7388 9.22039 20.7388 4.77899 18.3511 1.60032C18.02 1.15892 18.1089 0.531986 18.5503 0.199919C18.9917 -0.131148 19.6206 -0.0412808 19.9507 0.39912C22.8687 4.28586 22.8687 9.71359 19.9507 13.6003C19.6186 14.0431 18.9907 14.1298 18.5503 13.7995Z"
        fill="#637984"
      />
      <path
        d="M5.93212 11.6667C3.54932 9.00654 3.54932 4.99287 5.93212 2.33267C6.30125 1.92154 6.93606 1.88834 7.34426 2.25454C7.75539 2.62267 7.79052 3.25554 7.42239 3.66667C5.72119 5.56707 5.72119 8.43228 7.42239 10.3327C7.79052 10.7438 7.75539 11.3766 7.34426 11.7448C6.93452 12.1125 6.30065 12.079 5.93212 11.6667Z"
        fill="#637984"
      />
      <path
        d="M14.9555 11.7448C14.5444 11.3767 14.5092 10.7438 14.8774 10.3327C16.5786 8.43229 16.5786 5.56709 14.8774 3.66669C14.5092 3.25555 14.5444 2.62275 14.9555 2.25455C15.3656 1.88735 15.9994 1.92055 16.3676 2.33268C18.7505 4.99282 18.7505 9.00649 16.3676 11.6667C15.9992 12.0789 15.3653 12.1126 14.9555 11.7448Z"
        fill="#637984"
      />
      <path
        d="M11.1498 9.99964C9.49551 9.99964 8.14978 8.6539 8.14978 6.99964C8.14978 5.34537 9.49551 3.99963 11.1498 3.99963C12.8041 3.99963 14.1498 5.34537 14.1498 6.99964C14.1498 8.6539 12.8041 9.99964 11.1498 9.99964Z"
        fill="#637984"
      />
    </svg>
  ) : type === 'icon-email' ? (
    <svg width="80" height="60" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M72.4999 0H7.50005C3.36427 0 0 3.36427 0 7.50005V52.5C0 56.6358 3.36427 60.0001 7.50005 60.0001H72.4999C76.6357 60.0001 80 56.6358 80 52.5V7.50005C80 3.36427 76.6357 0 72.4999 0ZM72.4999 4.99998C72.8396 4.99998 73.1628 5.07045 73.4582 5.19353L40 34.1919L6.54167 5.19353C6.83708 5.07062 7.16022 4.99998 7.49989 4.99998H72.4999ZM72.4999 54.9999H7.50005C6.12068 54.9999 4.99998 53.8794 4.99998 52.4999V10.4761L38.3618 39.3896C38.833 39.7973 39.4165 40 40 40C40.5835 40 41.167 39.7974 41.6382 39.3896L75 10.4761V52.5C74.9999 53.8794 73.8793 54.9999 72.4999 54.9999Z"
        fill="#009DE6"
      />
    </svg>
  ) : (
    <IconWrapper
      className={'st-icon-wrapper ' + (className != undefined ? className : '')}
      size={size}
      {...otherProps}
    >
      {type === 'icon-dispatch' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Dispatch.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_Dispatch.svg')}`
              : `${require('./static/ST_S_Dispatch.svg')}`
          }
          alt="Dispatch Icon"
        />
      ) : type === 'icon-scheduling' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Scheduling.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_Scheduling.svg')}`
              : `${require('./static/ST_S_Scheduling.svg')}`
          }
          alt="Call Scheduling Icon"
        />
      ) : type === 'icon-call-booking' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_CallBooking.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_CallBooking.svg')}`
              : `${require('./static/ST_S_CallBooking.svg')}`
          }
          alt="Call Booking Icon"
        />
      ) : type === 'icon-marketing' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Marketing.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_Marketing.svg')}`
              : `${require('./static/ST_S_Marketing.svg')}`
          }
          alt="Marketing Icon"
        />
      ) : type === 'icon-reporting' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Reporting.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_Reporting.svg')}`
              : `${require('./static/ST_S_Reporting.svg')}`
          }
          alt="Reporting Icon"
        />
      ) : type === 'icon-intacct' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Intacct.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_Intacct.svg')}`
              : `${require('./static/ST_S_Intacct.svg')}`
          }
          alt="Intacct Icon"
        />
      ) : type === 'icon-quickbooks' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Quickbooks.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_Quickbooks.svg')}`
              : `${require('./static/ST_S_Quickbooks.svg')}`
          }
          alt="Quickbooks Icon"
        />
      ) : type === 'icon-mobile' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Mobile.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_Mobile.svg')}`
              : `${require('./static/ST_S_Mobile.svg')}`
          }
          alt="Mobile App Icon"
        />
      ) : type === 'icon-financing' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Financing.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_Financing.svg')}`
              : `${require('./static/ST_S_Financing.svg')}`
          }
          alt="Financing Icon"
        />
      ) : type === 'icon-customer-ex' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_CustomerEx.svg')}`
              : size === 'dark'
              ? `${require('./static/ST_D_CustomerEx.svg')}`
              : `${require('./static/ST_S_CustomerEx.svg')}`
          }
          alt="Customer Experience Icon"
        />
      ) : type === 'icon-hvac' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_HVAC.svg')}`
              : `${require('./static/ST_S_HVAC.svg')}`
          }
          alt="HVAC Icon"
        />
      ) : type === 'icon-plumbing' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Plumbing.svg')}`
              : `${require('./static/ST_S_Plumbing.svg')}`
          }
          alt="Plumbing Icon"
        />
      ) : type === 'icon-electorical' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Electorical.svg')}`
              : `${require('./static/ST_S_Electorical.svg')}`
          }
          alt="Electrical Icon"
        />
      ) : type === 'icon-garage' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Garage.svg')}`
              : `${require('./static/ST_S_Garage.svg')}`
          }
          alt="Garage Door Icon"
        />
      ) : type === 'icon-chimney' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Chimney.svg')}`
              : `${require('./static/ST_S_Chimney.svg')}`
          }
          alt="Chimney Sweep Icon"
        />
      ) : type === 'icon-water' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Water.svg')}`
              : `${require('./static/ST_S_Water.svg')}`
          }
          alt="Water Icon"
        />
      ) : type === 'icon-commercial' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Commercial.svg')}`
              : `${require('./static/ST_S_Commercial.svg')}`
          }
          alt="Commercial Icon"
        />
      ) : type === 'icon-grow-job-revenue' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_GrowJobRevenue.svg')}`
              : `${require('./static/ST_L_GrowJobRevenue.svg')}`
          }
          alt="Growth Icon"
        />
      ) : type === 'icon-connect' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_Connect.svg')}`
              : `${require('./static/ST_L_Connect.svg')}`
          }
          alt="Connect Icon"
        />
      ) : type === 'icon-amazing-ex' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_AmazingEx.svg')}`
              : `${require('./static/ST_L_AmazingEx.svg')}`
          }
          alt="Amazing Experience Icon"
        />
      ) : type === 'icon-find-person' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_FindP.svg')}`
              : `${require('./static/ST_L_FindP.svg')}`
          }
          alt="Find Person Icon"
        />
      ) : type === 'icon-signup' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_SignUp.svg')}`
              : `${require('./static/ST_L_SignUp.svg')}`
          }
          alt="Signup Icon"
        />
      ) : type === 'icon-grow-business' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_GrowBusiness.svg')}`
              : `${require('./static/ST_L_GrowBusiness.svg')}`
          }
          alt="Business Growth Icon"
        />
      ) : type === 'icon-cloud-platform' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_CloudPlatform.svg')}`
              : `${require('./static/ST_L_CloudPlatform.svg')}`
          }
          alt="Cloud Platform Icon"
        />
      ) : type === 'icon-expand-customer' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_ExpandCustomer.svg')}`
              : `${require('./static/ST_L_ExpandCustomer.svg')}`
          }
          alt="Expand Customer Icon"
        />
      ) : type === 'icon-make-happy' ? (
        <img
          src={
            size === 'large'
              ? `${require('./static/ST_L_MakeHappy.svg')}`
              : `${require('./static/ST_L_MakeHappy.svg')}`
          }
          alt="Happy Icon"
        />
      ) : type === 'icon-file' ? (
        <img src={`${require('./static/ST_L_File.svg')}`} alt="File Icon" />
      ) : type === 'icon-policy' ? (
        <img src={`${require('./static/ST_L_Policy.svg')}`} alt="Policy Icon" />
      ) : type === 'icon-security' ? (
        <img src={`${require('./static/ST_L_Security.svg')}`} alt="Security Icon" />
      ) : type === 'icon-person' ? (
        <img src={size === 'large' ? icon_person_big : icon_person} alt="Person Icon" />
      ) : type === 'icon-recycle' ? (
        <img src={size === 'large' ? icon_recycle_big : icon_recycle} alt="Recycle Icon" />
      ) : type === 'icon-graph' ? (
        <img src={size === 'large' ? icon_graph_big : icon_graph} alt="Graph Icon" />
      ) : type === 'icon-pointer' ? (
        <img src={icon_pointer} alt="Pointer Icon" />
      ) : type === 'icon-chatting' ? (
        <img src={icon_chatting} alt="Chatting Icon" />
      ) : type === 'icon-list' ? (
        <img src={size === 'large' ? icon_list_big : icon_list} />
      ) : type === 'icon-speed' ? (
        <img src={size === 'large' ? icon_speed_big : icon_speed} alt="Speed Icon" />
      ) : type === 'icon-alarm' ? (
        <img src={size === 'large' ? icon_alarm_big : icon_alarm} alt="Alarm Icon" />
      ) : type === 'icon-play-circle' ? (
        <img src={size === 'normal' ? icon_play_circle : icon_play_circle} alt="Play Icon" />
      ) : type === 'icon_careers' ? (
        <img src={icon_careers} alt="Careers Icon" />
      ) : type === 'icon_company' ? (
        <img src={icon_company} alt="Company Icon" />
      ) : type === 'icon_openings' ? (
        <img src={icon_openings} alt="Openings Icon" />
      ) : type === 'icon_partnershiops' ? (
        <img src={icon_partnershiops} alt="Partnerships Icon" />
      ) : type === 'icon_back' ? (
        <img src={icon_back} alt="Back Icon" />
      ) : type === 'icon-hvac-load-calc' ? (
        <img src={icon_hvac_load_calc} alt="HVAC Load Calc Icon" />
      ) : type === 'icon-business-valuation' ? (
        <img src={icon_business_valuation} alt="Business Valuation Icon" />
      ) : type === 'icon-payment' ? (
        <img src={`${require('./static/icon-payment.png')}`} alt="Payment Icon" />
      ) : type === 'icon-contracts' ? (
        <img src={`${require('./static/icon-contracts.png')}`} alt="Contracts Icon" />
      ) : type === 'icon-timesheets' ? (
        <img src={`${require('./static/icon-timesheets.png')}`} alt="Timesheets Icon" />
      ) : type === 'icon-payroll' ? (
        <img src={`${require('./static/payroll.png')}`} alt="Payroll Icon" />
      ) : type === 'icon-memberships' ? (
        <img src={`${require('./static/icon-memberships.png')}`} alt="Memberships Icon" />
      ) : (
        <></>
      )}
    </IconWrapper>
  );
};

STIcon.propTypes = {
  width: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string, // large, small, dark
};

STIcon.defaultProps = {
  size: 'small',
};

const IconWrapper = styled.div`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => (props.size == 'large' ? '80px' : '40px')};
  height: ${props => (props.size == 'large' ? '80px' : '40px')};
  min-width: ${props => (props.size == 'large' ? '80px' : '40px')};
  border: ${props =>
    props.size == 'large'
      ? '3px solid #E5EBEE'
      : props.size == 'small'
      ? '2px solid #E5EBEE'
      : 'none'};
`;
